// src/components/CustomerSignup.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../config";
import { trackSignUp } from "../utils/analytics";
import "./AuthForm.css"; // ✅ use shared CSS

const CustomerSignup = () => {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    dob: "",
    gender: "",
    address: "",
    state: "",
    pincode: "",
    email: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });

  const navigate = useNavigate();
  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const validateForm = () => {
    if (!form.name.trim()) return "Name is required";
    if (!/^[0-9]{10}$/.test(form.phone))
      return "Phone number must be 10 digits";
    if (!form.dob) return "Date of birth is required";
    if (!form.gender) return "Gender is required";
    if (!form.address.trim()) return "Address is required";
    if (!form.state.trim()) return "State is required";
    if (!/^[0-9]{6}$/.test(form.pincode))
      return "Pincode must be 6 digits";
    if (!/\S+@\S+\.\S+/.test(form.email))
      return "Invalid email format";
    if (form.password.length < 6)
      return "Password must be at least 6 characters";
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage({ type: "", text: "" });

    const errorMsg = validateForm();
    if (errorMsg) {
      setMessage({ type: "error", text: errorMsg });
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API_BASE_URL}/api/customers/signup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const data = await res.json();

      if (res.ok) {
        trackSignUp("email");
        setMessage({
          type: "success",
          text: "✅ Signup successful! Redirecting to login...",
        });
        setForm({
          name: "",
          phone: "",
          dob: "",
          gender: "",
          address: "",
          state: "",
          pincode: "",
          email: "",
          password: "",
        });
        setTimeout(() => navigate("/customer-login"), 1500);
      } else {
        setMessage({
          type: "error",
          text: data.error || data.message || "Signup failed",
        });
      }
    } catch (err) {
      console.error("🔥 Signup error:", err);
      setMessage({
        type: "error",
        text: "Something went wrong. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="auth-form" onSubmit={handleSubmit}>
      <h2>Customer Signup</h2>

      {message.text && (
        <div className={`message ${message.type}`}>{message.text}</div>
      )}

      <input
        name="name"
        placeholder="Full Name"
        value={form.name}
        onChange={handleChange}
        required
      />
      <input
        name="phone"
        type="tel"
        placeholder="Phone Number"
        value={form.phone}
        onChange={handleChange}
        required
      />

      <label>
        Date of Birth:
        <input
          type="date"
          name="dob"
          value={form.dob}
          onChange={handleChange}
          required
        />
      </label>

      <label>
        Gender:
        <select
          name="gender"
          value={form.gender}
          onChange={handleChange}
          required
        >
          <option value="">-- Select Gender --</option>
          <option value="male">Male</option>
          <option value="female">Female</option>
          <option value="other">Other</option>
        </select>
      </label>

      <input
        name="address"
        placeholder="Street Address"
        value={form.address}
        onChange={handleChange}
        required
      />
      <input
        name="state"
        placeholder="State"
        value={form.state}
        onChange={handleChange}
        required
      />
      <input
        name="pincode"
        type="number"
        placeholder="Pincode"
        value={form.pincode}
        onChange={handleChange}
        required
      />
      <input
        name="email"
        type="email"
        placeholder="Email"
        value={form.email}
        onChange={handleChange}
        required
      />
      <input
        name="password"
        type="password"
        placeholder="Password"
        minLength={6}
        value={form.password}
        onChange={handleChange}
        required
      />

      <button type="submit" disabled={loading}>
        {loading ? (
          <>
            <span className="spinner"></span> Signing up...
          </>
        ) : (
          "Sign Up"
        )}
      </button>
    </form>
  );
};

export default CustomerSignup;
